<template>
  <div class="menu-page">
    <v-card class="nd-border" flat>
      <v-card-title>
        Clientes
      </v-card-title>

      <v-card-text>
        <v-row class="d-flex align-center">
          <v-col cols="12" sm="6" class="d-flex">
            <ib-text-field v-model="search" class="mb-6" append-icon="mdi-magnify" label="Busque por nome ou e-mail" clearable outlined single-line hide-details style="max-width: 500px;" @input="searchOnServer" />
          </v-col>
          
          <v-col v-if="currentUser.admin" cols="12" sm="6" class="d-flex justify-end">
            <ib-btn color="primary" @click="dialogCreateAccount = true">
              <v-icon left>mdi-plus</v-icon>
              Criar conta
            </ib-btn>
          </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="objects" :options.sync="options" :server-items-length="totalObjects" :loading="loading">
          <template #[`item.created`]="{ item }">
            {{ new Date(item.created).toLocaleString('pt-BR').replace(',', ' -') }}
          </template>

          <template #[`item.name`]="{ item }">
            {{ item.override_name || item.name }}
          </template>

          <template #[`item.user_role`]="{ item }">
            <span v-if="item.user_role == 'owner'"> Proprietário(a)</span>
            <span v-if="item.user_role == 'manager'"> Gerente</span>
            <span v-if="item.user_role == 'user'"> Atendente</span>
          </template>

          <template #[`item.account.subscription_status`]="{ item }">
            <span v-if="item.account.subscription_status == 'active'"> <v-chip small color="success">Ativo</v-chip></span>
            <span v-if="item.account.subscription_status == 'canceled'"> <v-chip small color="error lighten-1">Cancelado</v-chip></span>
          </template>

          <template #[`item.account.custom_negotiation`]="{ item }">
            <span v-if="item.account.custom_negotiation"> Sim</span>
            <span v-if="!item.account.custom_negotiation"> Não</span>
          </template>

          <template #[`item.profile_picture`]="{ item }">
            <v-avatar size="60" class="my-2">
              <v-img v-if="item.profile_picture" :src="item.profile_picture" />
              <div v-else class="w-full h-full primary d-flex justify-center">
                <v-icon color="white" style="font-size:60px">
                  mdi-account
                </v-icon>
              </div>
            </v-avatar>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-menu>
              <template #activator="{ on, attrs }">
                <ib-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </ib-btn>
              </template>

              <v-card>
                <v-list-item @click="selectObject(item); dialog2 = true">
                  <v-list-item-icon>
                    <v-icon>mdi-lock-reset</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Mudar senha</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="item.user_role === 'owner'" @click="selectObject(item); loadServers(); dialog = true">
                  <v-list-item-icon>
                    <v-icon>mdi-file-edit-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="item.user_role === 'owner'" @click="selectObject(item); selectedAccount = item.account._id; openChips(item.account._id)">
                  <v-list-item-icon>
                    <v-icon>mdi-whatsapp</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Configurar números</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="item.user_role === 'owner'" @click="selectObject(item); selectedAccount = item.account._id; openDirectChips(item.account._id)">
                  <v-list-item-icon>
                    <v-icon>mdi-cellphone-link</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Conexão direta</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="item.user_role === 'owner' && item.account.subscription_status == 'active' && currentUser.admin" @click="selectObject(item); dialogCancelAccount = true">
                  <v-list-item-icon>
                    <v-icon>mdi-account-cancel</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Cancelar conta</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <ib-dialog v-model="dialog" scrollable max-width="900" persistent>
      <v-card>
        <ib-dialog-header title="Gerenciar conta" :close="() => { dialog = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_channels" class="pt-1" type="number" label="Limite de Chips (API não oficial)" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_users" class="pt-1" type="number" label="Limite de Usuários" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_flows" class="pt-1" type="number" label="Limite de Fluxos" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_summaries" class="pt-1" type="number" label="Resumos de IA" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_follow_ups" class="pt-1" type="number" label="Sugestões de follow-ups com IA" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_ai_replies" class="pt-1" type="number" label="Sugestões de resposta com IA" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-text-field v-model="object.account.max_official_channels" class="pt-1" type="number" label="Limite (API Oficial)" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" :md="object.account.waba ? 6 : 12">
              <ib-autocomplete v-model="object.account.server" class="pt-1" :items="servers" label="Server (API não oficial)" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6" v-if="object.account.waba">
              <ib-autocomplete v-model="object.account.official_api_server" class="pt-1" :items="official_servers" label="Server (API Oficial)" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6">
              <ib-autocomplete v-model="object.account.default_ai_model" class="pt-2" :items="ai_models" label="Modelo de IA para novos chatbots" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12" md="6" class="d-flex align-center">
              <ib-btn class="mt-2" color="primary" :loading="loading" @click.native="applyAiModelToChatbots">
                Aplicar a todos os chatbots da conta
              </ib-btn>
            </v-col>

            <v-col cols="12">
              <ib-btn class="mb-4 mr-2" color="primary" :loading="loading" @click.native="openLink('https://business.facebook.com/latest/settings/whatsapp_account?business_id=737867286595201&selected_asset_id=398882946650845&selected_asset_type=whatsapp-business-account')">
                Consultar WABA's
              </ib-btn>

              <ib-btn class="mb-4" color="primary" :loading="loading" @click.native="addWaba()">
                Adicionar WABA
              </ib-btn>

            </v-col>

            <v-col cols="12">
              <v-row v-for="(waba, index) in object.account.wabas" :key="`wabas_${index}`" class="d-flex align-center">
                <v-col cols="5">
                  <ib-text-field v-model="waba.name" class="pt-1" label="Nome WABA" outlined hide-details="auto" />
                </v-col>
                <v-col cols="5">
                  <ib-text-field v-model="waba.id" class="pt-1" label="ID WABA" outlined hide-details="auto" />
                </v-col>
                <v-col cols="2">
                  <v-btn small class="ml-2" icon color="error lighten-2" @click="object.account.wabas.splice(index, 1)">
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-switch v-model="object.account.campaigns_enabled" inset class="mt-0" label="Campanhas Habilitadas?" />
            </v-col>

            <v-col cols="12">
              <v-switch v-model="object.account.custom_negotiation" inset class="mt-0" label="Negociação customizada?" messages="Ative caso a conta receba alguma cortesia a mais do que seu plano permite (como um canal a mais). Dessa forma a cortesia não será perdida na renovação." />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click.native="dialog = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn class="mb-2" color="primary" :loading="loading" @click.native="save">
            Salvar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialog2" scrollable max-width="600" persistent>
      <v-card>
        <ib-dialog-header title="Mudar senha" :close="() => { dialog2 = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="6">
              <ib-text-field v-model="newPassword" class="pt-2" label="Nova senha" outlined hide-details="auto" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" />
            </v-col>

            <v-col cols="6">
              <ib-text-field v-model="confirmNewPassword" class="pt-2" label="Confirmar nova senha" outlined hide-details="auto" :type="showPassword ? 'text' : 'password'" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click.native="newPassword = ''; confirmNewPassword = ''; dialog2 = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn class="mb-2" color="primary" :loading="loading" @click.native="changePassword">
            Mudar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialog3" scrollable max-width="1000" persistent>
      <v-card>
        <ib-dialog-header title="Configurar números" :close="() => { dialog3 = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="6">
              <ib-autocomplete v-model="selectedWaba" class="mr-2 pt-2" :items="object.account.wabas" label="WABA" item-text="name" item-value="id" chips small-chips outlined clearable hide-details="auto" @change="phone_number_id_data = ''" />
            </v-col>
            <v-col cols="6">
              <ib-btn class="mt-2 mr-2" color="primary" :loading="loading" @click.native="getPhoneNumberId">
                Listar números do Waba
              </ib-btn>
            </v-col>

            <v-col cols="12" v-if="phone_number_id_data">
              <v-card>
                <v-card-title>
                  <span>Lista de Números</span>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="phone_search" append-icon="mdi-magnify" label="Buscar" single-line hide-details clearable class="mt-0 pt-0" style="max-width: 300px" />
                </v-card-title>

                <v-data-table :headers="phone_headers" :items="phone_number_id_data" :search="phone_search" :custom-filter="customFilter" class="elevation-1">

                  <template #[`item.quality_rating`]="{ item }">
                    <v-avatar size="16" :color="$ratingColor(item.quality_rating)" />
                  </template>

                  <template #[`item.actions`]="{ item }">
                    <v-menu class="d-flex">
                      <template #activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-list-item @click="createChip(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-plus-box-outline</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>Criar número</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-menu>
                  </template>

                </v-data-table>
              </v-card>
            </v-col>


            <v-col cols="12">
              <v-divider class="my-4"></v-divider>
              <h2 class="mb-1">Modo manual</h2>
              <span>Usar quando o chip já existe ou quando é necessário desregistrar ou registrar manualmente</span>

              <v-row class="mt-2">
                <v-col cols="6">
                  <ib-autocomplete @change="selectChip" class="pt-2" :items="chips" item-text="name" item-value="_id" return-object label="Selecione um número" chips small-chips outlined clearable hide-details="auto" />
                </v-col>

                <v-col cols="6" v-if="selectedChip?._id">
                  <ib-text-field v-model="selectedChip.name" class="pt-2" label="Nome do número" outlined hide-details="auto" />
                </v-col>

                <v-col cols="6" v-if="selectedChip?._id">
                  <ib-text-field v-model="selectedChip.phone_number_id" class="pt-2" label="Phone number ID" outlined hide-details="auto" />
                </v-col>

                <v-col cols="6" v-if="selectedChip?._id">
                  <ib-autocomplete v-model="selectedChip.status" class="pt-2" :items="statuses" label="Status" chips small-chips outlined clearable hide-details="auto" />
                </v-col>

                <v-col cols="6" v-if="selectedChip?._id">
                  <ib-autocomplete v-model="selectedChip.waba" class="pt-2" :items="object.account.wabas" label="WABA" item-text="name" item-value="id" chips small-chips outlined clearable hide-details="auto" />
                </v-col>

                <v-col cols="6" v-if="selectedChip?._id">
                  <v-switch inset v-model="selectedChip.registered" readonly class="pt-2" :label="selectedChip.registered ? 'Registrado' : 'Número não registrado!'" hide-details="auto" />
                </v-col>

                <v-col cols="12" v-if="selectedChip?._id">
                  <ib-btn class="mt-2 mr-2" color="primary" :loading="loading" @click.native="registerPhoneNumberId(false)">
                    Registrar número
                  </ib-btn>

                  <ib-btn class="mt-2 mr-2" color="error" :loading="loading" @click.native="registerPhoneNumberId(true)">
                    Desregistrar número
                  </ib-btn>

                  <ib-btn class="mt-2 mr-2" color="error" :loading="loading" @click.native="dialogDeleteChip = true">
                    Apagar número
                  </ib-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click.native="newPassword = ''; confirmNewPassword = ''; dialog3 = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn class="mb-2" color="primary" :loading="loading" @click.native="saveChipNumber">
            Salvar alterações
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogDeleteChip" overlay-opacity="0.5" overlay-color="black" max-width="420">
      <v-card>
        <ib-dialog-header title="Apagar número" subtitle="Certificar que está desconectado e desregistrado. Conversas abertas neste número serão encerradas." :close="() => { dialogDeleteChip = false }"></ib-dialog-header>

        <v-card-text>
          Tem certeza que deseja apagar o número <b>{{ selectedChip?.name }}</b>?
        </v-card-text>
        <v-card-actions>

          <ib-btn color="gray200" outlined @click="dialogDeleteChip = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="error" @click="dialogDeleteChip = false; deleteChip(selectedChip)">
            Apagar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogDirectChips" scrollable max-width="900" persistent>
      <v-card>
        <ib-dialog-header title="Conexão direta (não oficial)" subtitle="Arquivar remove o chip da conta e reseta a conexão obrigatoriamente. Resetar apenas desconecta e limpa as credenciais." :close="() => { dialogDirectChips = false }"></ib-dialog-header>

        <v-card-text>
          <v-data-table :headers="direct_chip_headers" :items="directChips" :loading="loading" hide-default-footer disable-pagination>
            <template #[`item.status`]="{ item }">
              <ib-chip v-if="item.status === 'open'" small class="my-1 mr-1 " :color="$vuetify.theme.themes.light.primary">
                Conectado
              </ib-chip>
              <ib-chip v-else small class="my-1 mr-1" :color="$vuetify.theme.themes.light.error">
                {{ connection_statuses[item.status] }}
              </ib-chip>
            </template>

            <template #[`item.actions`]="{ item }">
              <v-menu>
                <template #activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-list-item @click="selectedDirectChip = item; dialogResetDirectChip = true">
                    <v-list-item-icon>
                      <v-icon>mdi-restart</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>Resetar</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="selectedDirectChip = item; dialogArchiveDirectChip = true">
                    <v-list-item-icon>
                      <v-icon>mdi-archive-arrow-down-outline</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>Arquivar</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-menu>
            </template>

            <template #no-data>
              Nenhum chip de conexão direta encontrado.
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <ib-btn outlined color="gray200" @click.native="dialogDirectChips = false">
            <div class="gray1000--text">
              Fechar
            </div>
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogResetDirectChip" overlay-opacity="0.5" overlay-color="black" max-width="420">
      <v-card>
        <ib-dialog-header title="Resetar conexão" subtitle="O chip será desconectado e as credenciais apagadas. Será necessário reconectar lendo o QR Code novamente." :close="() => { dialogResetDirectChip = false }"></ib-dialog-header>

        <v-card-text>
          Tem certeza que deseja resetar o chip <b>{{ selectedDirectChip?.name }}</b>?
        </v-card-text>
        <v-card-actions>
          <ib-btn color="gray200" outlined @click="dialogResetDirectChip = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="error" :loading="loading" @click="resetDirectChip(selectedDirectChip)">
            Resetar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogArchiveDirectChip" overlay-opacity="0.5" overlay-color="black" max-width="420">
      <v-card>
        <ib-dialog-header title="Arquivar chip" subtitle="O chip será desconectado, resetado e removido da conta. Conversas abertas neste número serão encerradas." :close="() => { dialogArchiveDirectChip = false }"></ib-dialog-header>

        <v-card-text>
          Tem certeza que deseja arquivar o chip <b>{{ selectedDirectChip?.name }}</b>?
        </v-card-text>
        <v-card-actions>
          <ib-btn color="gray200" outlined @click="dialogArchiveDirectChip = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="error" :loading="loading" @click="archiveDirectChip(selectedDirectChip)">
            Arquivar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogCreateAccount" overlay-opacity="0.5" overlay-color="black" max-width="420">
      <v-card>
        <ib-dialog-header title="Criar conta" :close="() => { dialogCreateAccount = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <ib-text-field v-model="newAccountEmail" class="pt-1" label="Email da nova conta" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="adminPassword" class="pt-1" label="Sua senha" outlined hide-details="auto" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn color="gray200" outlined @click="dialogCreateAccount = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="primary" @click="createAccount()">
            Criar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="dialogCancelAccount" max-width="500" persistent>
      <v-card>
        <ib-dialog-header title="Cancelar Conta" :close="() => { dialogCancelAccount = false; cancelAccountPassword = '' }" />

        <v-card-text>
          <v-alert type="warning" text class="mb-4">
            Esta ação irá cancelar a conta permanentemente.
          </v-alert>

          <v-row>
            <v-col cols="12">
              <p class="mb-2"><strong>Conta:</strong> {{ object.name || object.email }}</p>
              <p class="text--secondary">Para confirmar o cancelamento, digite sua senha de administrador:</p>
            </v-col>

            <v-col cols="12">
              <ib-text-field 
                v-model="cancelAccountPassword" 
                label="Sua senha de administrador" 
                outlined 
                hide-details="auto" 
                :type="showCancelPassword ? 'text' : 'password'" 
                :append-icon="showCancelPassword ? 'mdi-eye' : 'mdi-eye-off'" 
                @click:append="showCancelPassword = !showCancelPassword"
                @keyup.enter="cancelAccount"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click="dialogCancelAccount = false; cancelAccountPassword = ''">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="error" :loading="loading" @click="cancelAccount">
            Confirmar Cancelamento
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>
  </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

let timeout = null;

export default {
  name: "AdminClientesView",

  data() {
    return {
      objects: [],
      object: { account: {} },
      totalObjects: 0,
      selectedAccount: null,
      chips: [],
      directChips: [],
      selectedDirectChip: null,
      dialogDirectChips: false,
      dialogResetDirectChip: false,
      dialogArchiveDirectChip: false,
      connection_statuses: {
        "close": "Desconectado",
        "new": "Desconectado",
        "open": "Conectado",
        "connecting": "Conectando",
        "configuring": "Configurar",
        "unavailable": "Indisponível",
      },
      search: "",
      phone_search: "",
      loading: true,
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialogDeleteChip: false,
      dialogCreateAccount: false,
      dialogCancelAccount: false,
      servers: [],
      official_servers: [],
      selectedContact: null,
      selectedChip: null,
      selectedWaba: null,
      newPassword: '',
      phone_number_id_data: '',
      phone_number_id: '',
      confirmNewPassword: '',
      showPassword: false,
      showCancelPassword: false,
      cancelAccountPassword: '',
      options: { itemsPerPage: 10 },
      statuses: ['open', 'configuring', 'close'],
      newAccountEmail: '',
      adminPassword: '',
      ai_models: [
        { text: 'GPT-4o mini', value: 'gpt-4o-mini' },
        { text: 'GPT-6 Luna (padrão)', value: 'gpt-6-luna-medium' }
      ],

      headers: [
        { text: 'Foto', value: 'profile_picture', sortable: false },
        { text: 'Nome', value: 'name', sortable: false },
        { text: "E-mail", value: "email", sortable: false },
        { text: "Tipo", value: "user_role", sortable: false },
        { text: "Plano", value: "account.plan_id", sortable: false },
        { text: "Status plano", value: "account.subscription_status", sortable: false },
        { text: "Plano customizado", value: "account.custom_negotiation", sortable: false },
        { text: 'Criação', value: 'created', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ],

      phone_headers: [
        { text: 'Telefone', value: 'display_phone_number' },
        { text: 'Nome Verificado', value: 'verified_name' },
        { text: 'Qualidade', value: 'quality_rating', align: 'center' },
        { text: 'Phone Number ID', value: 'id' },
        { text: 'Ações', value: 'actions' },
      ],

      direct_chip_headers: [
        { text: 'Nome', value: 'name', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    }
  },

  watch: {
    options: {
      handler() {
        this.getObjects(this.options);
      },
      deep: true,
    },
  },

  async mounted() {

  },

  methods: {
    selectObject(item) {
      this.object = JSON.parse(JSON.stringify(item))
    },

    async changePassword() {
      if (!this.newPassword || this.newPassword.length < 6) return emitToastr("error", "A senha deve ter pelo menos 6 dígitos");
      if (this.confirmNewPassword != this.newPassword) return emitToastr("error", "As senhas não conferem");

      this.loading = true;
      const resp = await Api.changeCustomerPassword(this.object._id, this.newPassword);
      this.loading = false;

      if (!resp.error && resp.message) {
        emitToastr("success", "Senha alterada com sucesso!");
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.showPassword = false;
        this.dialog2 = false;
      }
    },

    async getObjects(options) {
      this.loading = true;
      const resp = await Api.getCustomers({ ...options, query: this.search });
      this.loading = false;

      if (!resp.error && resp.message) {
        this.objects = resp.message.data;
        this.totalObjects = resp.message.total;
      }
    },

    async openChips(account) {
      this.chips = [];
      this.phone_number_id = '';
      await this.getAccountChips(account);
      this.dialog3 = true;
    },

    async getAccountChips(account) {
      this.loading = true;
      const resp = await Api.getOfficialChipNumbersByAccount(account);
      this.loading = false;

      if (!resp.error && resp.message) this.chips = resp.message;
    },

    async openDirectChips(account) {
      this.directChips = [];
      this.selectedDirectChip = null;
      await this.getAccountDirectChips(account);
      this.dialogDirectChips = true;
    },

    async getAccountDirectChips(account) {
      this.loading = true;
      const resp = await Api.getNonOfficialChipNumbersByAccount(account);
      this.loading = false;

      if (!resp.error && resp.message) this.directChips = resp.message;
    },

    async resetDirectChip(chip) {
      this.loading = true;
      const resp = await Api.adminUpdateChipNumber(chip._id, { reset: true });
      this.loading = false;

      if (!resp.error) {
        this.dialogResetDirectChip = false;
        this.selectedDirectChip = null;
        await this.getAccountDirectChips(this.selectedAccount);
        return emitToastr("success", "Chip resetado com sucesso!");
      }
    },

    async archiveDirectChip(chip) {
      this.loading = true;
      const resp = await Api.adminUpdateChipNumber(chip._id, { filed: true });
      this.loading = false;

      if (!resp.error) {
        this.dialogArchiveDirectChip = false;
        this.selectedDirectChip = null;
        await this.getAccountDirectChips(this.selectedAccount);
        return emitToastr("success", "Chip arquivado e resetado com sucesso!");
      }
    },

    async getPhoneNumberId() {
      this.loading = true;
      this.phone_number_id_data = '';
      const resp = await Api.getPhoneNumberId(this.selectedWaba);
      this.loading = false;

      if (resp.error && resp.message) {
        emitToastr("error", resp.message);
        return;
      }
      else {
        this.phone_number_id_data = resp.message?.data;
      }
    },

    async registerPhoneNumberId(deregister = false) {
      this.loading = true;
      const resp = await Api.registerPhoneNumberId(this.selectedChip.waba, this.selectedChip.phone_number_id, deregister, this.selectedChip.coex);
      this.loading = false;

      if (resp.error && resp.message) {
        emitToastr("error", resp.message);
        return;
      }
      else {
        const resp2 = await Api.adminUpdateChipNumber(this.selectedChip._id, { registered: !deregister });
        if (resp2.error) {
          emitToastr("error", resp2.message);
        }
        else {
          await this.getAccountChips(this.selectedAccount);
          this.selectedChip = this.chips.find(c => c._id === this.selectedChip._id);
          emitToastr("success", "Operação bem sucedida");
        }
      }
    },

    async deleteChip(chip) {
      this.loading = true;
      const resp = await Api.adminUpdateChipNumber(chip._id, { filed: true });
      this.loading = false;
      if (!resp.error) {
        this.selectedChip = null;
        await this.getAccountChips(this.selectedAccount);
        return emitToastr("success", "Número apagado com sucesso!");
      }
    },

    async createChip(chip) {
      this.loading = true;
      const resp = await Api.adminCreateChipNumber(this.selectedWaba, chip, this.selectedAccount);
      this.loading = false;
      if (!resp.error) {
        this.selectedChip = null;
        await this.getAccountChips(this.selectedAccount);
        return emitToastr("success", "Número criado com sucesso! Faça o registro e deixe online.");
      }
    },

    selectChip(data) {
      this.selectedChip = data;
      this.$forceUpdate();
    },

    async searchOnServer() {
      if (timeout) clearTimeout(timeout);
      this.loading = true;

      timeout = setTimeout(() => {
        this.options.page = 1;
        this.loading = false;
        this.getObjects(this.options);
      }, 1000);
    },

    customFilter(value, search, item) {
      if (!search) return true
      const searchLower = search.toString().toLowerCase()
      return (
        item.display_phone_number?.toLowerCase().includes(searchLower) ||
        item.verified_name?.toLowerCase().includes(searchLower) ||
        item.id?.toString().includes(searchLower)
      )
    },

    openLink(link) {
      window.open(link, "_blank");
    },

    addWaba() {
      if (!this.object?.account.wabas) this.object.account.wabas = [];
      this.object.account.wabas.push({ name: '', id: '' });
      this.$forceUpdate();
    },


    async saveChipNumber() {
      this.loading = true;
      const resp = await Api.createOrUpdateChipNumber(this.selectedChip);
      this.loading = false;
      if (!resp.error) return emitToastr("success", "Número atualizado com sucesso!");
    },

    async save() {
      if (isNaN(this.object.account.max_channels)) return emitToastr("error", "Quantidade de canais inválida!");
      if (isNaN(this.object.account.max_official_channels)) return emitToastr("error", "Quantidade de números (API Oficial) inválida!");
      if (isNaN(this.object.account.max_users)) return emitToastr("error", "Quantidade de usuários inválida!");
      if (isNaN(this.object.account.max_flows)) return emitToastr("error", "Quantidade de fluxos inválida!");
      if (isNaN(this.object.account.max_summaries)) return emitToastr("error", "Quantidade de resumos de IA inválida!");
      if (isNaN(this.object.account.max_follow_ups)) return emitToastr("error", "Quantidade de sugestões de follow-ups com IA inválida!");
      if (isNaN(this.object.account.max_ai_replies)) return emitToastr("error", "Quantidade de sugestões de resposta com IA inválida!");

      const original = this.objects.find(o => o._id === this.object._id);
      if (original?.account?.server !== this.object.account.server) {
        const confirmChangeServer = await this.$store.dispatch('confirmDialog', {
          title: "Mudar servidor",
          message: "O servidor da API não oficial foi alterado. Os chips não oficiais da conta serão desconectados e precisarão ler o QR Code novamente. Deseja continuar?"
        });

        if (!confirmChangeServer) return;
      }

      this.loading = true;
      const resp = await Api.updateAccount(this.object.account);
      this.loading = false;
      if (!resp.error && resp.message) {
        emitToastr("success", "Conta atualizada com sucesso!");
        this.dialog = false;
        this.options = { itemsPerPage: 10 };
        this.getObjects(this.options);
      }
    },

    async applyAiModelToChatbots() {
      if (!this.object.account.default_ai_model) return emitToastr("error", "Selecione um modelo de IA.");
      const confirmApply = await this.$store.dispatch('confirmDialog', {
        title: "Aplicar modelo de IA",
        message: "Todos os chatbots desta conta passarão a usar este modelo. Deseja continuar?"
      });

      if (!confirmApply) return;

      this.loading = true;
      const resp = await Api.applyAiModelToChatbots(this.object.account._id, this.object.account.default_ai_model);
      this.loading = false;
      if (!resp.error && resp.message) emitToastr("success", "Modelo aplicado a todos os chatbots da conta!");
    },

    async createAccount() {
      this.loading = true;
      const resp = await Api.adminCreateAccount(this.newAccountEmail, this.adminPassword);
      this.loading = false;
      if (!resp.error && resp.message) {
        emitToastr("success", "Conta criada com sucesso!");
        this.newAccountEmail = '';
        this.adminPassword = '';
        this.dialogCreateAccount = false;

        this.options = { itemsPerPage: 10 };    
        this.getObjects(this.options);
      } 
    },

    async cancelAccount() {
      if (!this.cancelAccountPassword || this.cancelAccountPassword.length < 6) {
        return emitToastr("error", "Digite sua senha de administrador para confirmar");
      }

      if (!this.object?._id || !this.object?.account?._id) {
        return emitToastr("error", "Erro ao identificar a conta");
      }

      this.loading = true;
      const resp = await Api.adminCancelAccount(this.object._id, this.object.account._id, this.cancelAccountPassword);
      this.loading = false;

      if (!resp.error && resp.message) {
        emitToastr("success", "Conta cancelada com sucesso!");
        this.cancelAccountPassword = '';
        this.showCancelPassword = false;
        this.dialogCancelAccount = false;
        this.getObjects(this.options);
      }
    },

    async loadServers() {
      const resp = await Api.getMessageServers();
      if (!resp.error && resp.message) {
        // Servidores inativos aparecem para exibir o servidor atual da conta, mas não podem ser escolhidos
        const toItem = s => ({ text: s.active ? s.name : `${s.name} (inativo)`, value: s.name, disabled: !s.active });
        this.servers = resp.message.filter(s => !s.official).map(toItem);
        this.official_servers = resp.message.filter(s => s.official).map(toItem);
      }
    }
  },
};
</script>

<style scoped></style>